export const data = {
  methods: {
    getData(businessId, district) {
      this.$store.dispatch('getCompanyData', {
        businessId,
        district,
      })
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/getData.js